export default __webpack_public_path__ + "static/media/speed-banners-ms.7207dad3.webp";